const authPasswordRequirementsLineHeight = 1.6;

export const authPasswordRequirementsTitleSx = {
  color: 'primary.main',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: authPasswordRequirementsLineHeight,
  margin: 0,
} as const;

export const authPasswordRequirementsListSx = {
  width: '100%',
} as const;

export const authPasswordRequirementsItemSx = {
  alignItems: 'center',
  columnGap: 0.5,
  py: 0.25,
} as const;

export const authPasswordRequirementsItemIconSx = {
  minWidth: 22,
} as const;

export const authPasswordRequirementsMetIconSx = {
  color: 'secondary.main',
  fontSize: 16,
} as const;

export const authPasswordRequirementsUnmetIconSx = {
  color: 'action.disabled',
  fontSize: 16,
} as const;

export const authPasswordRequirementsItemTextSx = {
  color: 'primary.main',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: authPasswordRequirementsLineHeight,
} as const;
